export const shadows = {
    sm: '0 2px 4px 0 rgb(144 164 174 / 20%)',
}
